/**********************
 * These functions are duplicated from general/queryParams.js
 * If you edit them, do it in both places
 **********************/
function getQueryStringParams(query) {
    // noinspection DuplicatedCode
    if (query == null) return {};

    // new Uri(query) expects a full URL string, however the original version of getQueryStringParams
    // expected the query string after ? only -- to fix, check for ? and = and add back uri if necessary
    if (query.indexOf('=') > -1 && query.indexOf('?') === -1) {
        query = '?' + query;
    }

    const uri = new Uri(query);
    const params = {};
    uri.queryPairs.forEach(function (pair) {
        const key = pair[0];
        const val = pair[1];
        const currentValue = params[key];
        if (currentValue == null) {
            params[key] = val;
        } else if (Array.isArray(currentValue)) {
            currentValue.push(val);
        } else {
            params[key] = [currentValue, val];
        }
    });

    return params;
}

export function getURLParams(fullURL) {
    return getQueryStringParams(fullURL);
}

export function getURLParam(fullURL, param) {
    const queryParams = getURLParams(fullURL);
    return queryParams[param];
}

/**********************
 * END functions duplicated from general/queryParams.js
 * Functions below this point only exist in this file
 **********************/

/**
 * Sorts query params alphabetically by key.
 * Can be used to maximize cache hits.
 */
export function sortQueryParams(query) {
    if (query.indexOf('?') === 0) {
        query = query.substring(1);
    }
    const params = query.split('&');
    params.sort();
    return params.join('&');
}

export function removeUTMParams(fullURL) {
    return new Uri(fullURL)
        .deleteQueryParam('utm_campaign')
        .deleteQueryParam('utm_medium')
        .deleteQueryParam('utm_source')
        .deleteQueryParam('utm_content')
        .deleteQueryParam('utm_term')
        .toString();
}

// use when setting webflow _eventId params
export function removeEventIdFromURLString(urlString) {
    const url = new Uri(urlString);
    url.deleteQueryParam('_eventId');
    const query = url.query().slice(1).split('&');
    for (let i = 0; i < query.length; i++) {
        if (query[i].indexOf('_eventId_') === 0) {
            url.deleteQueryParam(query[i]);
        }
    }
    return url.toString();
}
